import { IOptions } from '../../../components/ingredients/Ingredients'
import {
    brandsToOption,
    categoriesToOption,
    createProductFormIds,
    imageToBase64,
} from '../../../formatters'
import { useLoadingContext } from '../../../context/spinnerContext'
import { ChangeEvent, FormEvent, useEffect, useRef, useState } from 'react'
import useDisclosure from '../../../hooks/useDisclosure'
import useAsyncSelect from '../../../hooks/useAsyncSelect'
import {
    addIngredients,
    addStock,
    changePrice,
    createProduct,
    localBrands,
    localCategories,
    updateIngredients,
    updateProduct,
    uploadImage,
} from '../../../services/products'
import { labels } from '../../../labels'
import { MEASURES } from '../../../constants'
import { getLocal } from '../../../Utils/Profile'

const getCommerceID = () => {
    const commerce = localStorage.getItem('currentUser')
    const commerceData: ICommerceBO = commerce ? JSON.parse(commerce) : null
    return commerceData.sEstablecimiento + getLocal()
}
const MB_SIZE = 1024 * 1024
const MAX_MB_IMAGE = 2
const ingredientsKey = 'ingredients'
const initialForm: ICreateProductForm = {
    productName: '',
    fullDescription: '',
    price: '',
    productBrandID: '',
    productCategoryID: '',
    productImage: '',
    productMeasureUnit: MEASURES[0].label,
    shortDescription: '',
    stock: '',
    isFood: true,
    weight: '',
    ean: '',
    sku: '',
    costPrice: '',
    inStoreSales: false,
    salesInApp: false,
}

export default function useIndividualUpload(initialData?: ICreateProductForm) {
    const [isPublic, setIsPublic] = useState<boolean>()
    const {
        open: openRespnseOK,
        handleClose: handleCloseResponseOk,
        handleOpen: handleOpenResponseOK,
    } = useDisclosure()
    const {
        open: openResponseError,
        handleClose: handleCloseResponseError,
        handleOpen: handleOpenResponseError,
    } = useDisclosure()
    const loadingContext = useLoadingContext()
    const [errors, setError] = useState<ICreateProductFormErrors | null>(null)
    const [form, setForm] = useState<ICreateProductForm>(
        initialData || initialForm
    )
    const [isValidForm, setIsValidForm] = useState<boolean>(false)
    const [image, setImage] = useState<File | null>(null)
    const [imageBase64, setImageBase64] = useState<string>('')
    const { handleOptionSelect: handleSelectBrand, optionID: brandID } =
        useAsyncSelect()

    const { handleOptionSelect: handleSelectCategory, optionID: categoryID } =
        useAsyncSelect()
    const [isFood, setIsFood] = useState<boolean>(true)
    const brands = brandsToOption(localBrands())
    const categories = categoriesToOption(localCategories())
    const formRef = useRef<HTMLFormElement>(null)
    const [ingredients, setIngredients] = useState<IOptions | undefined>()
    const handleIngredients = (newIngredients: IOptions | undefined) => {
        setIngredients(newIngredients)
    }
    const [showError, setShowErrors] = useState<boolean>(false)

    const validateIngredients = () => {
        let ingredientsValid = true
        if (ingredients) {
            if (ingredients.length > 0) {
                ingredients.forEach((element) => {
                    if (!element.maximumQuantity) {
                        ingredientsValid = false
                    }
                    if (!element.name) {
                        ingredientsValid = false
                    }
                    element.options.forEach((item) => {
                        if (!item.name) {
                            ingredientsValid = false
                        }
                        if (!item.price) {
                            ingredientsValid = false
                        }
                    })
                    handleError(ingredientsKey, labels.ingredientsError)
                })
            } else {
                handleError(ingredientsKey, labels.ingredientsEmpty)
                ingredientsValid = false
            }
        }
        if (ingredientsValid) {
            setError(null)
        }
        return ingredientsValid
    }

    const validateIds = () => {
        let isValid = true
        if (!brandID) {
            handleError(createProductFormIds.productBrandID, labels.required)
            isValid = false
        } else if (!brands.find((element) => element.label === brandID)) {
            handleError(
                createProductFormIds.productBrandID,
                labels.noValidOption
            )
            isValid = false
        }
        if (!categoryID) {
            handleError(createProductFormIds.productCategoryID, labels.required)
            isValid = false
        } else if (
            !categories.find((element) => element.label === categoryID)
        ) {
            handleError(
                createProductFormIds.productCategoryID,
                labels.noValidOption
            )
            isValid = false
        }
        return isValid
    }

    const validateImage = () => {
        console.log('productImage', form.productImage)
        if (
            typeof form.productImage === 'string' &&
            form.productImage.length > 0
        ) {
            return true
        }
        let isValid = true
        if (!image) {
            isValid = false
        }
        if (image && image?.size / MB_SIZE > MAX_MB_IMAGE) {
            handleError(
                createProductFormIds.productImage,
                labels.imageSizeError
            )
            isValid = false
        }
        return isValid
    }

    const validateFullForm = () => {
        let formKey: keyof ICreateProductForm
        let isValid = true
        let validImage = true
        if (!isPublic) {
            validImage = validateImage()
        }
        for (formKey in form) {
            if (
                ![
                    createProductFormIds.productBrandID,
                    createProductFormIds.productCategoryID,
                    createProductFormIds.productImage,
                    createProductFormIds.productMeasureUnit,
                    createProductFormIds.isFood,
                    createProductFormIds.salesInApp,
                    createProductFormIds.inStoreSales,
                    createProductFormIds.sku,
                    createProductFormIds.weight,
                    createProductFormIds.ean,
                    createProductFormIds.shortDescription,
                    createProductFormIds.public,
                ].includes(formKey) &&
                !form[formKey]
            ) {
                handleError(formKey as string, labels.required)
                console.log('AAAA', formKey)
                isValid = false
            }
        }
        console.log('AA', form.inStoreSales, form.salesInApp)
        if (!form.inStoreSales && !form.salesInApp) {
            handleError('inStoreSales', labels.required)
            handleError('salesInApp', labels.required)
            isValid = false
        }
        const validIds = validateIds()
        console.log('AA', validIds, validImage, isValid)

        isValid = validIds && validImage && isValid
        return isValid
    }
    const onCategoryChange = (newValue: string | null) => {
        handleSelectCategory(newValue)
    }
    const onBrandChange = (newValue: string | null) => {
        handleSelectBrand(newValue)
    }
    const oneEANChange = (newValue?: any) => {
        setIsPublic(false)
        if (newValue) {
            const { productBrandID, productCategoryID }: ICreateProductForm =
                newValue
            const foundBrand = brands.find((item) => item.id == productBrandID)
            const foundCategory = categories.find(
                (item) => item.id == productCategoryID
            )
            if (foundBrand) {
                onBrandChange(foundBrand.label)
            }
            if (foundCategory) {
                onCategoryChange(foundCategory.label)
            }
            const transformedProduct: any = {}
            Object.keys(initialForm).map((k) => {
                transformedProduct[k] = newValue[k]
            })
            setForm({ ...transformedProduct, sku: '' })
            setIsPublic(true)
            setImage(null)
        } else {
            handleSelectBrand(null)
            handleSelectCategory(null)
            setForm({ ...initialForm })
            setIsPublic(false)
            setImage(null)
        }
    }

    const handleChangeString = (name: string, value: string) => {
        setForm((prevState) => ({ ...prevState, [name]: value }))
    }
    const handleChangeBoolean = (name: string, value: boolean) => {
        setForm((prevState) => ({ ...prevState, [name]: value }))
    }
    const handleInitForm = (form: ICreateProductForm) => {
        setForm(form)
    }
    const handleChange = (event: FormEvent<HTMLInputElement>) => {
        const value = event.currentTarget.value
        const name = event.currentTarget.name
        setForm((prevState) => ({ ...prevState, [name]: value }))
    }
    const handleUnit = (element: ChangeEvent<HTMLSelectElement>) => {
        setForm((prevState) => ({
            ...prevState,
            ['productMeasureUnit']: element.target.value,
        }))
    }
    const handleFood = (value: boolean) => {
        setIsFood(value)
    }
    const handleError = (key: string, label: string) => {
        setError((prevState) => ({ ...prevState, [key]: label }))
        setIsValidForm(false)
    }

    const validate = () => {
        const validForm = validateFullForm()
        const validIngredients = validateIngredients()
        const isValid = validForm && validIngredients
        if (!isValid) {
            setShowErrors(true)
            setIsValidForm(false)
        } else {
            setShowErrors(false)
            setIsValidForm(true)
        }

        return isValid
    }

    const handleImage = (base64: string) => {
        setImageBase64(base64)
    }
    const onError = () => {
        loadingContext?.onClose()
        handleOpenResponseError()
    }
    const handleSubmit = async () => {
        const formatedData: ICreateProductForm = {
            ...form,
            productBrandID: brandID ? brandID : '0',
            productCategoryID: categoryID ? categoryID : '0',
            productImage: imageBase64,
            isFood: isFood,
        }
        loadingContext?.onOpen()

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
        if (isPublic) {
            const responseCreateProduct: ILiquidateCreated =
                await createProduct({
                    ...formatedData,
                })

            await addStock(
                formatedData.stock,
                responseCreateProduct.id,
                formatedData.weight,
                formatedData.productMeasureUnit,
                formatedData.inStoreSales,
                formatedData.salesInApp
            )
            await changePrice(
                formatedData.price || '',
                responseCreateProduct.id,
                1,
                form.costPrice
            )

            handleOpenResponseOK()
            loadingContext?.onClose()
        } else if (formatedData.productImage) {
            try {
                const image: string = await uploadImage(imageBase64)
                const responseCreateProduct: ILiquidateCreated =
                    await createProduct({
                        ...formatedData,
                        productImage: image,
                    })

                await addStock(
                    formatedData.stock,
                    responseCreateProduct.id,
                    formatedData.weight,
                    formatedData.productMeasureUnit,
                    formatedData.inStoreSales,
                    formatedData.salesInApp
                )
                await changePrice(
                    formatedData.price || '',
                    responseCreateProduct.id,
                    1,
                    form.costPrice
                )

                if (ingredients) {
                    const formatIngredients = ingredients.reduce(
                        (acc: AddIngredient[], el): AddIngredient[] => {
                            const typeIngredients: Ingredient[] =
                                el.options.map((item): Ingredient => {
                                    return {
                                        name: item.name,
                                        price: +item.price,
                                        maxAmount: +el.maximumQuantity,
                                    }
                                })
                            return [
                                ...acc,
                                {
                                    ingredients: typeIngredients,
                                    mandatory: el.required,
                                    maxAmount: +el.maximumQuantity,
                                    multichoice: false,
                                    name: el.name,
                                    productID: responseCreateProduct.id,
                                    internalCommerceID: +getCommerceID(),
                                },
                            ]
                        },
                        []
                    )
                    await addIngredients(
                        responseCreateProduct.id,
                        formatIngredients
                    )
                }
                handleOpenResponseOK()
            } catch (e) {
                onError()
            } finally {
                loadingContext?.onClose()
            }
        }
    }

    const handleSubmitEdit = async () => {
        const formatedData: ICreateProductForm = {
            ...form,
            shortDescription: null,
            productBrandID: brandID ? brandID : '0',
            productCategoryID: categoryID ? categoryID : '0',
            productImage: imageBase64,
            isFood: isFood,
        }
        loadingContext?.onOpen()

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
        try {
            if (!form.id) {
                return
            }
            let photo: string = imageBase64 && (await uploadImage(imageBase64))
            if (!photo) {
                if (typeof form.productImage === 'string') {
                    photo = form.productImage
                }
            }
            const cat = categories.find(
                (element) => element.label === categoryID
            ) || { id: '0' }
            const brand = brands.find(
                (element) => element.label === brandID
            ) || { id: '0' }

            const params: IEditProduct = {
                sku: form.sku,
                productName: form.productName,
                fullDescription: form.fullDescription,
                shortDescription: form.shortDescription,
                photoURL: photo,
                productCategoryID: Number(cat.id),
                productBrandID: Number(brand.id),
                isFood: form.isFood,
                inStoreSales: form.inStoreSales,
                salesInApp: form.salesInApp,
            }

            await updateProduct(params)

            await addStock(
                formatedData.stock,
                form.id,
                formatedData.weight,
                formatedData.productMeasureUnit,
                formatedData.inStoreSales,
                formatedData.salesInApp
            )
            await changePrice(
                formatedData.price || '',
                form.id,
                1,
                form.costPrice
            )

            const formatAddIngredients = ingredients?.filter((i) => !i.id)
            const formatUpdateIngredients =
                ingredients?.filter((i) => i.id) || []
            console.log('AAA formatUpdateIngredients', formatUpdateIngredients)

            if (formatUpdateIngredients) {
                await updateIngredients(
                    form.id,
                    formatUpdateIngredients.reduce(
                        (acc: UpdateIngredient[], el): UpdateIngredient[] => {
                            return [
                                ...acc,
                                {
                                    ...el,
                                    id: Number(el.id),
                                    ingredients: el.options.map((item) => ({
                                        ...item,
                                        id: item.id,
                                        name: item.name,
                                        price: +item.price,
                                        maxAmount: +el.maximumQuantity,
                                    })),
                                    name: el.name,
                                    multichoice: false,
                                    mandatory: el.required,
                                    productID: form.id || 0,
                                    maxAmount: +el.maximumQuantity,
                                    internalCommerceID: +getCommerceID(),
                                    ingredientTypeID: Number(el.id),
                                },
                            ]
                        },
                        []
                    )
                )
            }
            if (formatAddIngredients && formatAddIngredients.length > 0) {
                await addIngredients(
                    form.id,
                    formatAddIngredients.reduce(
                        (acc: AddIngredient[], el): AddIngredient[] => {
                            const typeIngredients: Ingredient[] =
                                el.options.map((item): Ingredient => {
                                    return {
                                        name: item.name,
                                        price: +item.price,
                                        maxAmount: +el.maximumQuantity,
                                    }
                                })
                            return [
                                ...acc,
                                {
                                    ingredients: typeIngredients,
                                    mandatory: el.required,
                                    maxAmount: +el.maximumQuantity,
                                    multichoice: false,
                                    name: el.name,
                                    productID: form.id || 0,
                                    internalCommerceID: +getCommerceID(),
                                },
                            ]
                        },
                        []
                    )
                )
            }

            handleOpenResponseOK()
        } finally {
            loadingContext?.onClose()
        }
    }

    const handleFile = (e: FormEvent<HTMLInputElement>) => {
        const file = e?.currentTarget?.files?.[0] || null
        setImage(file)
        setError(null)
        validateFullForm()
    }

    useEffect(() => {
        imageToBase64(image, handleImage)
    }, [image])

    useEffect(() => {
        setError(null)
        const ingredientsValid = validateIngredients()
        const fullValid = validateFullForm()
        setIsValidForm(ingredientsValid && fullValid)
    }, [ingredients, categoryID, brandID, image, form])

    const handleCloseResponse = () => {
        handleCloseResponseOk()
        location.reload()
    }
    return {
        setIsPublic,
        isPublic,
        brandID,
        categoryID,
        formRef,
        errors,
        isValidForm,
        openRespnseOK,
        showError,
        openResponseError,
        handleSelectBrand: onBrandChange,
        handleSelectEAN: oneEANChange,
        handleSelectCategory: onCategoryChange,
        handleUnit,
        handleChange,
        handleChangeString,
        handleChangeBoolean,
        validate,
        handleSubmit,
        handleSubmitEdit,
        handleFile,
        handleCloseResponseOk: handleCloseResponse,
        handleCloseResponseError,
        handleFood,
        handleIngredients,
        handleInitForm,
        form,
    }
}
